import Swal from 'vue-simple-alert';
// import router from '../router';

export default class Errors {
  constructor() {
    this.initHandler();
  }

  static onError(error) {
    this.displayErrorAlert(error);
    Errors.logRocketLogEngine(error);
    return false;
  }

  static onWarn(error) {
    // Send Error to Log Engine e.g LogRocket
    this.logRocketLogEngine(error);
  }

  static onInfo(error) {
    // You can handle this differently
    this.sentryLogEngine(error);
  }

  static onDebug(error) {
    const { response } = error;
    if (response && response.status >= 400 && response.status < 405) {
      // You can handle this differently
      this.sentryLogEngine(error);
      return false;
    }
    // Send Error to Log Engine e.g LogRocket
    this.logRocketLogEngine(error);

    return false;
  }

  static initHandler() {
    const scope = this;
    window.onerror = (message, url, lineNo, columnNo, error) => {
      if (error) {
        scope.onError(error);
        // eslint-disable-next-line no-console
        console.log(message, url, lineNo, columnNo, error);
      }
    };
  }

  static displayErrorAlert(error) {
    let message = '';
    let title = 'Erreur applicative';
    if (error.response != null) {
      if (error.response.data != null) {
        if (Number(error.response.data.status) === 404 || Number(error.response.data.status) === 500) {
          message = 'La mise à jour au niveau de l\'API a échoué';
        } else if (Number(error.response.data.status) === 401) {
          message = 'Vous n’avez pas les droits pour accéder à ces données';
          title = 'Accès non-autorisé';
        } else if (error.response.data.title != null) {
          // eslint-disable-next-line no-console
          console.log(error.response.data);
          message = error.response.data.title.substring(0, 200);
        } else if (typeof error.response.data === 'string' || error.response.data instanceof String) {
          message = error.response.data.substring(0, 200);
        } else message = '';
      } else message = '';
    } else message = '';
    Swal.fire({
      title,
      text: message,
      type: 'error',
    }).then(() => {
      if (message.includes('ERR221')) {
        // router.push('/').catch(() => {});
        window.location.reload();
      } else if (message.includes('Code 401')) {
        window.location.reload();
      } // else router.push('Error').catch(() => {});
    });
  }

  static logRocketLogEngine(error) {
    // LogRocket.captureException(error);
    // eslint-disable-next-line no-console
    console.log('Devo', error);
  }

  static sentryLogEngine(error) {
    // Implement Sentry Engine here
    // eslint-disable-next-line no-console
    console.log('Devo', error);
  }
}
